import { Button, Col, Form, Input, Option, Row, Select } from "@tv2no/ui-react";
import React, { useEffect, useState } from "react";
import { getTaxYearList } from "../../api/services/taxYear";

export const PersonSearchForm = ({ selectedYear, onSearch, busy }) => {
    const [year, setYear] = useState(selectedYear);
    const [yearList, setYearList] = useState(null);
    const [firstName, setFirstName] = useState(null);
    const [middleName, setMiddleName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [birthYear, setBirthYear] = useState(null);

    useEffect(() => {
        getTaxYearList().then((result) => {
            setYearList(result);
        });
    }, []);

    return (
        <Form>
            <Row spacing="small">
                <Col xs={24} md={8} lg={4}>
                <Select value={year} placeholder="Skatteår" onChange={setYear}>
                        {yearList &&
                            yearList.map((entry) => (
                                <Option key={entry.year} value={entry.year}>
                                    {entry.year}
                                </Option>
                            ))}
                    </Select>
                </Col>
            </Row>
            <Row gutter={["tiny", "tiny"]}>
                <Col xs={12} md={12} lg={6}>
                    <Input placeholder="Fornavn" value={firstName} onChange={setFirstName} />
                </Col>
                <Col xs={12} md={12} lg={5}>
                    <Input placeholder="Mellomnavn" value={middleName} onChange={setMiddleName} />
                </Col>
                <Col xs={12} md={12} lg={5}>
                    <Input placeholder="Etternavn" value={lastName} onChange={setLastName} />
                </Col>
                <Col xs={12} md={12} lg={4}>
                    <Input
                        type="number"
                        placeholder="Født år"
                        value={birthYear}
                        onChange={setBirthYear}
                    />
                </Col>
                <Col xs={6} md={12} lg={4}>
                    <Button
                        fill
                        type="submit"
                        busy={busy}
                        icon="search"
                        color="primary"
                        onClick={() => onSearch({ year, firstName, middleName, lastName, birthYear, size: 50 })}
                        disabled={!year}
                    >
                        Søk
                    </Button>
                </Col>
            </Row>
        </Form>
    );
};
